import type { Project } from '../types'

type Tab =
  | 'schedule'
  | 'decisions'
  | 'budget'
  | 'change-orders'
  | 'daily-log'
  | 'inspections'
  | 'materials'
  | 'draws'
  | 'punch'
  | 'subs'
  | 'selections'
  | 'scope'
  | 'site-walks'
  | 'plans'
  | 'spec'
  | 'digest'
  | 'warranty'
  | 'today'
  | 'compliance'
  | 'bids'
  | 'lessons'
  | 'financials'
  | 'insights'
  | 'inbox'
  | 'comms'
  | 'lots'
  | 'lead-inbox'
  | 'settings'

export type { Tab }

// Header now owns brand + project select + action buttons only. Tab nav
// moved to <TabNav /> sibling rendered by App.tsx so the two-row grouped
// pattern can stretch full-width below the header chrome.
export default function Header({
  projects,
  activeProjectId,
  onProjectChange,
  onExport,
  onNewProject,
  onInviteClient,
}: {
  projects: Project[]
  activeProjectId: string | null
  onProjectChange: (id: string) => void
  onExport?: () => void
  onNewProject?: () => void
  onInviteClient?: () => void
}) {
  return (
    <header className="hdr">
      <div className="brand">
        <img src="/logo.png" alt="Heritage Homes" className="brand-logo" />
        <div className="brand-text">
          <div className="brand-name">Heritage Homes</div>
          <div className="brand-sub">COMMAND CENTER</div>
        </div>
      </div>

      <select
        className="proj-select"
        value={activeProjectId ?? ''}
        onChange={(e) => {
          if (e.target.value === '__new__') onNewProject?.()
          else onProjectChange(e.target.value)
        }}
      >
        {projects.length === 0 && <option value="">No projects</option>}
        {projects.map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
          </option>
        ))}
        <option value="__new__">+ New project…</option>
      </select>

      <div className="hdr-spacer" />

      {onInviteClient && (
        <button
          className="export-btn"
          onClick={onInviteClient}
          title="Invite a client to this project"
        >
          + Invite
        </button>
      )}
      {onExport && (
        <button className="export-btn" onClick={onExport} title="Download project as JSON">
          ↓ Export
        </button>
      )}
    </header>
  )
}
